import React from 'react';
import { connect } from 'react-redux';
import firebase from 'firebase';

var docINE = "ife.jpg"
const mapState = (state) => {
    return {
        ife: state.miPerfil.ife,
        tarjetaCirculacion: state.miPerfil.tarjetaCirculacion,
        licencia: state.miPerfil.licencia,
        nameIfe: state.miPerfil.archivoIfe,
        nameTC: state.miPerfil.archivoTarjetaCirculacion,
        nameLic: state.miPerfil.archivoLicencia,
        cveCliente: state.global.uid
    };
}

const mapDispatch = (dispatch) => {
    return {
        setIfe: (img) => {
            dispatch({ "type": "MI_PERFIL_SET_IFE", "img": img});
        },
        setTC: (img) => {
            dispatch({ "type": "MI_PERFIL_SET_TC", "img": img});
        },
        setLic: (img) => {
            dispatch({ "type": "MI_PERFIL_SET_LIC", "img": img});
        },
        setDocumentosFlag: (flag) => {
            dispatch({ "type": "MI_PERFIL_SET_DOCUMENTOS_FLAG", flag:flag });
        },
        setArchivoIfe: (name) => {
            dispatch({ "type": "MI_PERFIL_SET_ARCHIVO_IFE", "ife": name});
        },
         setArchivoTc: (name) => {
            dispatch({ "type": "MI_PERFIL_SET_ARCHIVO_TC", "tc": name});
        },
         setArchivoLic: (name) => {
            dispatch({ "type": "MI_PERFIL_SET_ARCHIVO_LIC", "lic": name});
        },
        alerta: (titulo, mensaje) => {
            dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": titulo, "mensaje": mensaje})
        },
        setLoad: (val) => {
            dispatch({ "type": "LOADER", "show": val});
        },
        addEvento: (evento) => {
			dispatch({ "type": "MI_PERFIL_SET_EVENT", "evento": evento});
		}
    }
}

class Documentos extends React.Component {
    state = {
        editing: false,
        spanClassIfe: this.props.ife.length > 0 ? "upload-wrap uploaded-file" : "upload-wrap",
        spanClassTarjetaCirculacion: this.props.tarjetaCirculacion.length > 0 ? "upload-wrap uploaded-file" : "upload-wrap",
        spanClassLicencia: this.props.licencia.length > 0 ? "upload-wrap uploaded-file" : "upload-wrap",
        ifeFile: {},
        tcFile: {},
        licFile: {},
        ifeUrl: this.props.ife.length > 0 ? this.props.ife : "",
        tcUrl: this.props.tarjetaCirculacion.length > 0 ? this.props.tarjetaCirculacion : "",
        licUrl: this.props.licencia.length > 0 ? this.props.licencia : ""
    }

    edit = () => {
        /*console.log(this.props.ife.length > 30 ? this.props.ife.substring(0, 27) + "..." : this.props.ife);
        console.log(this.props.tarjetaCirculacion.length > 30 ? this.props.tarjetaCirculacion.substring(0, 27) + "..." : this.props.tarjetaCirculacion);
        console.log(this.props.licencia.length > 30 ? this.props.licencia.substring(0, 27) + "..." : this.props.licencia);*/
        this.setState({editing: !this.state.editing});
    }
    changeInputFile = (event) => {
        let id = event.target.id;
        let reader = new FileReader();
        let file = event.target.files[0];
        let ext = file.name.split('.').pop().toLowerCase();
        console.log("Cargar.... "+ id);

        if(ext == "jpg" || ext == "png" || ext == "bmp" || ext == "jpeg"){
            reader.onloadend = () => {
            switch(id) {
                case "fileIfe":
                     console.log("cargo ife");
                    // this.props.setIfe(reader.result);
                    this.setState({ifeFile: file});
                    this.setState({ifeUrl: reader.result});
                    this.setState({spanClassIfe: "upload-wrap uploaded-file"});
                    this.setState({disabledIfe: true});
                    break;
                case "fileTarjetaCirculacion":
                     console.log("cargo tc");
                    // this.props.setTC(reader.result);
                    this.setState({tcFile: file});
                    this.setState({tcUrl: reader.result});
                    this.setState({spanClassTarjetaCirculacion: "upload-wrap uploaded-file"});
                    this.setState({disabledTarjetaCirculacion: true});
                    break;
                case "fileLicencia":
                    console.log("cargo lic");
                    // this.props.setLic(reader.result);
                    this.setState({licFile: file});
                    this.setState({licUrl: reader.result});
                    this.setState({spanClassLicencia: "upload-wrap uploaded-file"});
                    this.setState({disabledLicencia: true});
                    break;
            }
        }

        reader.readAsDataURL(file);
        }
        else {
            this.props.addEvento("FormatoIncorrecto-Documentos");
            this.props.alerta("Error","El documento debe ser una imagen en formato: jpg, png o bmp.");
            switch(id) {
                case "fileIfe":
                    this.refs.ife.value="";
                    break;
                case "fileTarjetaCirculacion":
                    this.refs.tarjetaCirculacion.value="";
                    break;
                case "fileLicencia":
                    this.refs.licencia.value="";
                    break;
            }
        }

    }
    borrar = (event) => {
        let id = event.target.id;
        switch(id) {
                case "borrarIfe":
                    this.refs.ife.value="";
                    this.setState({ifeFile: {}});
                    this.setState({ifeUrl: ""});
                    this.setState({spanClassIfe: "upload-wrap"});
                    this.setState({disabledIfe: false});
                    break;
                case "borrarTarjetaCirculacion":
                    this.refs.tarjetaCirculacion.value="";
                    this.setState({tcFile: {}});
                    this.setState({tcUrl: ""});
                    this.setState({spanClassTarjetaCirculacion: "upload-wrap"});
                    this.setState({disabledTarjetaCirculacion: false});
                    break;
                case "borrarLicencia":
                    this.refs.licencia.value="";
                    this.setState({licFile: {}});
                    this.setState({licUrl: ""});
                    this.setState({spanClassLicencia: "upload-wrap"});
                    this.setState({disabledLicencia: false});
                    break;
            }
    }
    cancel = () => {
        console.log("Cancelar ife: " + this.props.ife);
        console.log("Cancelar tc: " + this.props.tarjetaCirculacion);
        console.log("Cancelar lic: " + this.props.licencia);
        this.props.addEvento("Cancelar-Documentos");
        this.setState({ifeFile: {}});
        this.setState({tcFile: {}});
        this.setState({licFile: {}});
        this.setState({ifeUrl: this.props.ife.length > 0 ? this.props.ife : ""});
        this.setState({tcUrl: this.props.tarjetaCirculacion.length > 0 ? this.props.tarjetaCirculacion : ""});
        this.setState({licUrl: this.props.licencia.length > 0 ? this.props.licencia : ""});
        if(this.props.ife.length == 0) {
            this.setState({spanClassIfe: "upload-wrap"});
            this.setState({disabledIfe: false});
        } else {
            this.setState({spanClassIfe: "upload-wrap uploaded-file"});
            this.setState({disabledIfe: true});
        }
        if(this.props.tarjetaCirculacion.length == 0) {
            this.setState({spanClassTarjetaCirculacion: "upload-wrap"});
            this.setState({disabledTarjetaCirculacion: false});
        } else {
            this.setState({spanClassTarjetaCirculacion: "upload-wrap uploaded-file"});
            this.setState({disabledTarjetaCirculacion: true});
        }
        if(this.props.licencia.length == 0) {
            this.setState({spanClassLicencia: "upload-wrap"});
            this.setState({disabledLicencia: false});
        } else {
            this.setState({spanClassLicencia: "upload-wrap uploaded-file"});
            this.setState({disabledLicencia: true});
        }
        this.edit();
    }
    save = () => {
        console.log("Clave cliente: "+this.props.cveCliente);
        var tthis = this;
         var storageRef = firebase.storage().ref('documentos/' + this.props.cveCliente + '/');

        this.refs.tarjetaCirculacion.value="";
        this.refs.ife.value="";
        this.refs.licencia.value="";

        let obj = {ife: "", tc: "", lic: "", ifeUrl: this.props.ife, tcUrl: this.props.tarjetaCirculacion, licUrl: this.props.licencia};
        if(this.state.ifeFile.name && this.state.ifeUrl) {
            console.log("entro a ife");
            if(this.props.nameIfe != ""){
                var refIfe = storageRef.child(docINE);
                //var desertRef = storageRef.getReferenceFromUrl(this.state.ifeUrl)
                console.log("referencia ife: " + refIfe);
                refIfe.delete().then(function() {
                    tthis.props.setArchivoIfe("");
                    console.log("Se borro correctamente el documento ife: "+this.state.ifeUrl);
                }).catch(function(error) {
                   console.log("Ocurrió un error al borrar if");
                });
            }
        //let metadata = { contentType: this.state.ifeFile.type };
        let metadata = { contentType: "image/jpeg" };
        obj.ife = this.state.ifeFile;
        obj.ifeUrl = this.state.ifeUrl;
        //let ext = this.state.ifeFile.name.substr(this.state.ifeFile.name.lastIndexOf('.') + 1);
        this.props.setLoad(true);
        var uploadTaskIfe = storageRef.child(docINE).put(this.state.ifeFile, metadata);

        uploadTaskIfe.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          function(snapshot) {
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED:
                console.log('Upload is paused');
                break;
              case firebase.storage.TaskState.RUNNING:
                console.log('Upload is running');
                break;
            }
          }, function(error) {
          switch (error.code) {
            case 'storage/unauthorized':
                console.log("Permisos denegados al storage");
              break;
            case 'storage/canceled':
                console.log("Storage cancelado");
              break;
            case 'storage/unknown':
                console.log("Storage no reconocido");
              break;
          }
        }, function() {
          var urlIFE = uploadTaskIfe.snapshot.downloadURL;
          console.log("Añadido correctamente " + urlIFE);
          let data = {ife: urlIFE};
          firebase.database().ref("miPerfil/" + tthis.props.cveCliente + "/documentos").update(data);
          tthis.props.addEvento("AgregoIFE-Documentos");
          tthis.props.setIfe(urlIFE);
          tthis.props.setArchivoIfe(docINE);
          tthis.props.setLoad(false);
          });
        }
        else if(this.props.ife != "" && this.state.ifeUrl == ""){


            console.log("storageRef: " + storageRef+" ife: "+this.props.nameIfe);
            var refIfe = storageRef.child(docINE);
            //var desertRef = storageRef.getReferenceFromUrl(this.state.ifeUrl)
                console.log("referencia ife: " + refIfe);
                refIfe.delete().then(function() {
                    let data = {ife: ""};
                    firebase.database().ref("miPerfil/" + tthis.props.cveCliente + "/documentos").update(data);
                    tthis.props.setIfe("");
                    tthis.props.setArchivoIfe("");
                    tthis.props.addEvento("BorroIFE-Documentos");
                }).catch(function(error) {
                   console.log("Ocurrió un error al borrar ife: "+error);
            });
        }
        if(this.state.tcFile.name && this.state.tcUrl) {
             console.log("entro a tc");

             if(this.props.nameTC != ""){
                //var desertRef = storageRef.getReferenceFromUrl(this.state.tcUrl)
                var refTC = storageRef.child("tarjeta_circulacion.jpg");
                console.log("referencia tc: " + refTC);
                refTC.delete().then(function() {
                    tthis.props.setArchivoTc("");
                    console.log("Se borro correctamente el documento tc: "+tthis.state.ifeUrl);
                }).catch(function(error) {
                   console.log("Ocurrió un error al borrar if");
                });
            }

            let metadata = { contentType: "image/jpeg" };
            //let metadata = { contentType: this.state.tcFile.type };

            obj.tc = this.state.tcFile;
            obj.tcUrl = this.state.tcUrl;
            let ext = this.state.tcFile.name.substr(this.state.tcFile.name.lastIndexOf('.') + 1);
            this.props.setLoad(true);
            var uploadTaskTC = storageRef.child("tarjeta_circulacion.jpg").put(this.state.tcFile, metadata);

            uploadTaskTC.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
              function(snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
                switch (snapshot.state) {
                  case firebase.storage.TaskState.PAUSED:
                    console.log('Upload is paused');
                    break;
                  case firebase.storage.TaskState.RUNNING:
                    console.log('Upload is running');
                    break;
                }
              }, function(error) {
              switch (error.code) {
                case 'storage/unauthorized':
                    console.log("Permisos denegados al storage");
                  break;
                case 'storage/canceled':
                    console.log("Storage cancelado");
                  break;
                case 'storage/unknown':
                    console.log("Storage no reconocido");
                  break;
              }
            }, function() {
              var urlTC = uploadTaskTC.snapshot.downloadURL;
              console.log("Añadido correctamente " + urlTC);
              //let data = {tarjetaCirculacion: "tarjeta_circulacion." + ext};
              let data = {tarjetaCirculacion: urlTC};
              firebase.database().ref("miPerfil/" + tthis.props.cveCliente + "/documentos").update(data);
              tthis.props.setTC(urlTC);
              tthis.props.setArchivoTc("tarjeta_circulacion.jpg");
              tthis.props.setLoad(false);
              tthis.props.addEvento("AgregoTCirculacion-Documentos");
              });
        }
        else if(this.props.tarjetaCirculacion != "" && this.state.tcUrl == ""){
            console.log("storageRef: " + storageRef+" tc: "+this.props.nameTC);
            //var desertRef = storageRef.getReferenceFromUrl(this.state.tcUrl)

            var refTC = storageRef.child("tarjeta_circulacion.jpg");
            console.log("referencia tc: " + refTC);

                refTC.delete().then(function() {
                    let data = {tarjetaCirculacion: ""};
                    firebase.database().ref("miPerfil/" + tthis.props.cveCliente + "/documentos").update(data);
                    tthis.props.setTC("");
                    tthis.props.setArchivoTc("");
                    tthis.props.addEvento("BorroTCirculacion-Documentos");
                }).catch(function(error) {
                   console.log("Ocurrió un error al borrar tc: "+error);
            });
        }
        if(this.state.licFile.name && this.state.licUrl) {
             console.log("entro a licencia");
            obj.lic = this.state.licFile;
            obj.licUrl = this.state.licUrl;

            if(this.props.nameLic != ""){
                var refLic = storageRef.child("licencia.jpg");
                //var desertRef = storageRef.getReferenceFromUrl(this.state.licUrl)
                console.log("referencia lic: " + refLic);
                refLic.delete().then(function() {
                    tthis.props.setArchivoLic("");
                    console.log("Se borro correctamente el documento ife: "+tthis.state.ifeUrl);
                }).catch(function(error) {
                   console.log("Ocurrió un error al borrar if");
                });
            }

            let metadata = { contentType: "image/jpeg" };

            //let ext = this.state.licFile.name.substr(this.state.licFile.name.lastIndexOf('.') + 1);
            this.props.setLoad(true);
            var uploadTaskLic = storageRef.child("licencia.jpg").put(this.state.licFile, metadata);

            uploadTaskLic.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
              function(snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
                switch (snapshot.state) {
                  case firebase.storage.TaskState.PAUSED:
                    console.log('Upload is paused');
                    break;
                  case firebase.storage.TaskState.RUNNING:
                    console.log('Upload is running');
                    break;
                }
              }, function(error) {
              switch (error.code) {
                case 'storage/unauthorized':
                    console.log("Permisos denegados al storage");
                  break;
                case 'storage/canceled':
                    console.log("Storage cancelado");
                  break;
                case 'storage/unknown':
                    console.log("Storage no reconocido");
                  break;
              }
            }, function() {
              var urlLIC = uploadTaskLic.snapshot.downloadURL;
              console.log("Añadido correctamente " + urlLIC);
              //let data = {licenciaConducir: "licencia." + ext};
              let data = {licenciaConducir: urlLIC};
              firebase.database().ref("miPerfil/" + tthis.props.cveCliente + "/documentos").update(data);
              tthis.props.setLic(urlLIC);
              tthis.props.setArchivoLic("licencia.jpg");
              tthis.props.setLoad(false);
              tthis.props.addEvento("AgregoLicencia-Documentos");
              });
        }
        else if(this.props.licencia != "" && this.state.licUrl == ""){
            console.log("storageRef: " + storageRef+" lic: "+this.props.nameLic);
            //var desertRef = storageRef.getReferenceFromUrl(this.state.licUrl)

            var refLicencia = storageRef.child("licencia.jpg");
            console.log("referencia lic: " + refLicencia);

                refLicencia.delete().then(function() {
                    let data = {licenciaConducir: ""};
                    firebase.database().ref("miPerfil/" + tthis.props.cveCliente + "/documentos").update(data);
                    tthis.props.setLic("");
                    tthis.props.setArchivoLic("");
                    tthis.props.addEvento("BorroLicencia-Documentos");
                }).catch(function(error) {
                   console.log("Ocurrió un error al borrar lic: "+error);
            });
        }
        console.log(obj);
        if(obj.ife != "" || obj.tc != "" || obj.lic != "") {
            console.log("si");
            this.props.setDocumentosFlag(true);
        } else {
            console.log("no");
            this.props.setDocumentosFlag(false);
        }
        this.setState({ifeFile: {}});
        this.setState({tcFile: {}});
        this.setState({licFile: {}});
        //this.props.setTC(obj.tcUrl);
        //this.props.setLic(obj.licUrl);
        this.edit();
    }

    componentWillReceiveProps(nextProps) {
        console.log("Entro a actualizar");
        console.log(nextProps);
        this.setState({
            spanClassIfe:  nextProps.ife.length > 0 ? "upload-wrap uploaded-file" : "upload-wrap",
            spanClassTarjetaCirculacion:  nextProps.tarjetaCirculacion.length > 0 ? "upload-wrap uploaded-file" : "upload-wrap",
            spanClassLicencia:  nextProps.licencia.length > 0 ? "upload-wrap uploaded-file" : "upload-wrap",
            ifeUrl: nextProps.ife.length > 0 ? nextProps.ife : "",
            tcUrl: nextProps.tarjetaCirculacion.length > 0 ? nextProps.tarjetaCirculacion : "",
            licUrl: nextProps.licencia.length > 0 ? nextProps.licencia : ""
        });
   }
   componentDidMount = () => {
    var storageRef = firebase.storage().ref('documentos/' + this.props.cveCliente + '/');
    var refIfe = storageRef.child("ife.jpg");
    var refIfe2 = storageRef.child("INE_IFE.jpg");
    var refTC = storageRef.child("tarjeta_circulacion.jpg");
    var refLic = storageRef.child("licencia.jpg");
    refIfe.getDownloadURL().then(result=> {
        docINE = "ife.jpg";
        this.setState({ifeUrl: result});
        this.props.setIfe(result);
    }).catch(function(error) {
    });
    refIfe2.getDownloadURL().then(result=> {
        docINE = "INE_IFE.jpg"
        this.setState({ifeUrl: result});
        this.props.setIfe(result);
    }).catch(function(error) {
    });
    refTC.getDownloadURL().then(result=> {
        this.setState({tcUrl: result});
        this.props.setTC(result);
    }).catch(function(error) {
    });
    refLic.getDownloadURL().then(result=> {
        this.setState({licUrl: result});
        this.props.setLic(result);
    }).catch(function(error) {
    });
}

	render() {
		return <div className="col-xs-12">
            <div className="card perfil-card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-xs-6">
                            <i><img src={ require("../img/documentos-icono.svg") } /></i><b>Documentos</b>
                        </div>
                        <div className="col-xs-6">
                            <div className="text-right card-actions-btn">
                                { !this.state.editing &&
                                    <a id="doc_edit" onClick={this.edit} className="orange-btn">Editar <img src={ require("../img/editar-icono.png") } /></a>
                                }
                                { this.state.editing &&
                                    <div>
                                        <a id="doc_cancel" onClick={this.cancel} className="pad-right-10">Cancelar</a>
                                        <a id="doc_acept" onClick={this.save} className="orange-btn">Guardar</a>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <p>Agrega una fotografía de cada uno de tus documentos. En caso de siniestro las necesitaremos para tu atención.</p>
                    </div>
                    <div className="col-xs-12 mt-25">
                        <div className="row">
                            <div className="col-xs-4 text-center">
                                <span className={ this.state.spanClassIfe }>
                                    <i className="upload-icon"></i>
                                    <input id="fileIfe" ref="ife" type="file" disabled={!this.state.editing} onChange={this.changeInputFile} />
                                    { this.state.ifeUrl.length > 0 &&
                                      <a href={this.state.ifeUrl} target="_blank">
                                        <img src={this.state.ifeUrl} />
                                      </a>
                                    }
                                </span>
                                { this.state.editing && this.state.ifeUrl &&
                                    <button id="borrarIfe" onClick={this.borrar}>X</button>

                                }
                                <p className="text-center">IFE / INE</p>
                            </div>
                            <div className="col-xs-4 text-center">
                                <span className={this.state.spanClassTarjetaCirculacion}>
                                    <i className="upload-icon"></i>
                                    <input id="fileTarjetaCirculacion" ref="tarjetaCirculacion" type="file" disabled={!this.state.editing} onChange={this.changeInputFile} />
                                    { this.state.tcUrl.length > 0 &&
                                      <a href={this.state.tcUrl} target="_blank">
                                        <img src={this.state.tcUrl} />
                                      </a>
                                    }
                                </span>
                                { this.state.editing && this.state.tcUrl &&
                                    <button id="borrarTarjetaCirculacion" onClick={this.borrar}>X</button>
                                }
                                <p className="text-center">Tarjeta de circulación</p>
                            </div>
                            <div className="col-xs-4 text-center">
                                <span className={this.state.spanClassLicencia}>
                                    <i className="upload-icon"></i>
                                    <input id="fileLicencia" ref="licencia" type="file" disabled={!this.state.editing} onChange={this.changeInputFile} />
                                    { this.state.licUrl.length > 0 &&
                                      <a href={this.state.licUrl} target="_blank">
                                        <img src={this.state.licUrl} />
                                      </a>
                                    }
                                </span>
                                { this.state.editing && this.state.licUrl &&
                                    <button id="borrarLicencia" onClick={this.borrar}>X</button>

                                }
                                <p className="text-center">Licencia de conducir</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
	}
}

export default connect(mapState, mapDispatch)(Documentos);



// WEBPACK FOOTER //
// ./src/miPerfil/documentos.cmpt.js